import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ValidationService } from '../../../shared/providers/validation.service';
import { ToastService } from '../../../shared/providers/toast.service'
import { CommonService } from '../../../shared/providers/common.service';
import { LoaderService } from '../../../shared/providers/loader.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { IGuarantor, IGuarantorRating } from '../../../shared/models/GuarantorModels';
import { RatingAgency } from '../../../shared/enum/enum';
import { PropertyManagementService } from '../../../shared/providers/property-management.service';
import { ILookUp } from '../../../shared/models/LookUpOutputModel';
import { AuthenticationService } from '../../../shared/auth/authentication.service';

@Component({
    selector: 'app-add-guarantor',
    templateUrl: './add-guarantor.component.html'
})

export class AddGuarantorComponent implements OnInit {

    isSubmit = false;
    @Input() modalRef: BsModalRef;
  @Input() guarantorId: number;
  @Input() tenantId: number = 0;
    @Output() closeModal = new EventEmitter();
    modalHeaderText = "Add Guarantor";
    guarantor = {} as IGuarantor;
    ratingAgency = RatingAgency;
    sprRatingList: ILookUp[];
    moodysRatingList: ILookUp[];
    fitchRatingList: ILookUp[];
    URLValid = true;
    user: any;

    constructor(private authService: AuthenticationService, private Toast: ToastService, private Loader: LoaderService, private _propertyManagementService: PropertyManagementService, private modalService: BsModalService, public Validation: ValidationService, private Common: CommonService) { }

    ngOnInit() {
        this.bindRatings();
        this.user = this.authService.user;
        console.log(this.guarantorId);
        if (!this.Validation.IsinValid(this.guarantorId) && this.guarantorId != 0) {
            this.modalHeaderText = "Edit Guarantor";
            this.Common.GetGuarantorDetails(this.guarantorId).subscribe(res => {
                this.guarantor.Id = res["GuarantorId"];
                this.guarantor.Name = res["GuarantorName"];
                this.guarantor.URL = res["URL"];
                this.guarantor.GuarantorRating = [];
                let rating: IGuarantorRating[] = [] = res["GuarantorRating"];
                this.resetFeilds();
                rating.forEach(item => {
                    if (item.RatingAgengyType == this.ratingAgency.SandPRating) {
                        this.guarantor.SPRatingId = item.RatingId;
                    }
                    else if (item.RatingAgengyType == this.ratingAgency.MoodysRating) {
                        this.guarantor.MoodyRatingId = item.RatingId;
                    }
                    else if (item.RatingAgengyType == this.ratingAgency.FitchRating) {
                        this.guarantor.FitchRatingId = item.RatingId;
                    }
                });
            });
        }
        else {
            this.guarantor.Id = null;
            this.resetFeilds()
            this.modalHeaderText = "Add Guarantor";
        }
    }
    resetFeilds() {
        this.guarantor.SPRatingId = 0;
        this.guarantor.MoodyRatingId = 0;
        this.guarantor.FitchRatingId = 0;
    }
    bindRatings() {
        this.Loader.display(true);
        this._propertyManagementService.getSAndPRatingList().subscribe(response => {
            this.sprRatingList = response.map(o => {
                return { id: o.Id, description: o.Description };
            });
        });

        this._propertyManagementService.getMoodysRatingList().subscribe(response => {
            this.moodysRatingList = response.map(o => {
                return { id: o.Id, description: o.Description };
            });
        });

        this._propertyManagementService.getFitchRatingList().subscribe(response => {
            this.fitchRatingList = response.map(o => {
                return { id: o.Id, description: o.Description };
            });
            this.Loader.display(false);
        });
    }

  closeModalHide() {
    this.modalRef.hide();
    this.closeModal.emit(false);
  }

    saveGuarantor() {
        this.guarantor.UserId = this.user.Id;
        this.isSubmit = true;
        let valid = true;
        //if (this.Validation.IsinValid(this.guarantor.Name) || (this.guarantor.SPRatingId == 0 && this.guarantor.MoodyRatingId == 0 && this.guarantor.FitchRatingId == 0)) {
        //    valid = false;
        //}
        if (this.Validation.IsinValid(this.guarantor.Name)) {
            valid = false;
        }
        if (!this.Validation.IsinValid(this.guarantor.URL) && this.Validation.isUrlValid(this.guarantor.URL) == false) {
            this.URLValid = false;
            valid = false;
        }
        else {
            this.URLValid = true;
        }
        if (valid) {
            this.Loader.display(true);
            this.guarantor.GuarantorRating = [];
            if (!this.Validation.IsinValid(this.guarantor.SPRatingId) && this.guarantor.SPRatingId != 0) {
                const rating =
                    {
                        RatingAgengyType: this.ratingAgency.SandPRating,
                        RatingId: this.guarantor.SPRatingId
                    }
                this.guarantor.GuarantorRating.push(rating);
            }

            if (!this.Validation.IsinValid(this.guarantor.MoodyRatingId) && this.guarantor.MoodyRatingId != 0) {
                const rating =
                    {
                        RatingAgengyType: this.ratingAgency.MoodysRating,
                        RatingId: this.guarantor.MoodyRatingId
                    }
                this.guarantor.GuarantorRating.push(rating);
            }

            if (!this.Validation.IsinValid(this.guarantor.FitchRatingId) && this.guarantor.FitchRatingId != 0) {
                const rating =
                    {
                        RatingAgengyType: this.ratingAgency.FitchRating,
                        RatingId: this.guarantor.FitchRatingId
                    }
                this.guarantor.GuarantorRating.push(rating);
          }

          this.guarantor.TenantId = this.tenantId;
          this.Common.saveGuarantor(this.guarantor).subscribe(res => {
            console.log(res)
                if (res['IsSuccess']) {
                    this.Toast.addToast({ title: 'Success', msg: 'Guarantor added Successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
                  this.closeModal.emit(res['Id']);

                    this.modalRef.hide();
                }
                else {
                    this.Toast.addToast({ title: 'Error Occurred', msg: res['ErrorMessage'], timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
                }
                this.Loader.display(false);
            });
        }
  }


}
